// Detail amounts are Pro (owner decision 2026-08-07). Every client write path
// funnels its macro/micro fields through here, so a free account can never
// send details it isn't entitled to log — the server would 402 the write and
// the flow would look broken (the launch bug: free barcode adds wedged on the
// confirm card). Premium passes everything through untouched.
export interface DetailFields {
  protein_g?: number | null;
  carbs_g?: number | null;
  fat_g?: number | null;
  sugar_g?: number | null;
  fiber_g?: number | null;
  micros?: Record<string, number> | null;
}

const NONE: DetailFields = {
  protein_g: null, carbs_g: null, fat_g: null, sugar_g: null, fiber_g: null, micros: null,
};

export function detailAllowance(premium: boolean, details: DetailFields): DetailFields {
  return premium ? details : NONE;
}
